var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dash_icon",style:({ backgroundImage: `url(${_vm.currentBackground})` }),attrs:{"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }